// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // production: false,
  // bffUrl: 'http://localhost:3000/bff',
  // imgHandlerDomain: 'https://d1p5iip9d35kf5.cloudfront.net/fit-in/800x1000/'
  production: true,
  bffUrl: 'https://stg-api.trendsafe.io/bff',
  imgHandlerDomain: 'https://d1p5iip9d35kf5.cloudfront.net/fit-in/800x1000/'
  // whitelistUrl: 'localhost:8100'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
